import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=5f2305e8&scoped=true"
import script from "./DepartmentList.vue?vue&type=script&lang=js"
export * from "./DepartmentList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=5f2305e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2305e8",
  null
  
)

export default component.exports